import Extrato from "./Extrato";

export default Extrato;
